import { CircularSegmentElementProps } from "./AnalyzeInterface";
import { Card } from "semantic-ui-react";
import {
    CircularProgressIndicatorsCard,
    GeneralTextFields,
    InnerCardContentDiv,
    ProgressIndicatorInnerSegment,
    ProgressIndicatorOuterSegment,
    TotalCounter,
} from "./AnalyzeStyle";
import { Header } from "grabcad-ui-elements";

export const CircularSegmentElement = ({ total, element }: CircularSegmentElementProps) => {
    return (
        <CircularProgressIndicatorsCard>
            <Card.Content textAlign="left">
                <InnerCardContentDiv>
                    <ProgressIndicatorOuterSegment circular>
                        <ProgressIndicatorInnerSegment circular>
                            <Header as="h2">
                                <TotalCounter>{total}</TotalCounter>
                            </Header>
                        </ProgressIndicatorInnerSegment>
                    </ProgressIndicatorOuterSegment>
                    <GeneralTextFields data-testid={element}>
                        {element}
                        <br />
                        Connections
                    </GeneralTextFields>
                </InnerCardContentDiv>
            </Card.Content>
        </CircularProgressIndicatorsCard>
    );
};
